import type { CyclesSettings } from '@xox/shared'
import { Flag, Zap } from 'lucide-react'
import { useEffect } from 'react'
import { PartyHome } from '../components/PartyHome'
import { CyclesCreatePanel } from '../cycles/CyclesCreatePanel'
import { useCreateAndEnter } from '../hooks/useCreateRoom'
import { api } from '../lib/api'
import { feedback } from '../lib/feedback'
import { useSession } from '../store/session'

/** A quick match against three bots, no settings to pick. */
const QUICK_PLAY: CyclesSettings = { rounds: 3, bots: 3 }

const RULES = [
  'Your cycle never stops. Tap left or right to turn.',
  'Every cell you cross becomes a wall. Walls never vanish.',
  'Touch anything and you crash. Last rider standing wins the round.',
]

export function CyclesHome() {
  const load = useSession((s) => s.load)
  const { create, creating, error } = useCreateAndEnter(api.createCyclesRoom, '/cycles/r')

  useEffect(() => {
    void load()
  }, [load])

  return (
    <PartyHome
      current="/cycles"
      roomPath="/cycles/r"
      create={{
        title: 'Open an arena',
        tabLabel: 'Create',
        icon: <Flag className="size-5 lg:mr-1 lg:inline lg:size-4" aria-hidden />,
        panel: <CyclesCreatePanel onCreate={(s) => create(s)} creating={creating} error={error} />,
      }}
      join={{ id: 'cycles-join-code', label: 'Have an arena code?', title: 'Join an arena' }}
      firstTab={() => ({
        key: 'quick',
        label: 'Quick play',
        icon: <Zap className="size-5" aria-hidden />,
        disabled: creating,
        onSelect: () => {
          feedback('go')
          void create(QUICK_PLAY)
        },
      })}
    >
      <section aria-labelledby="rules" className="flex flex-col gap-2">
        <h2 id="rules" className="text-sm font-bold uppercase tracking-wide text-slate-500">
          How to ride
        </h2>
        <ol className="grid gap-2 sm:grid-cols-3">
          {RULES.map((rule, i) => (
            <li
              key={rule}
              className="flex gap-3 rounded-2xl bg-white p-3 text-sm ring-1 ring-slate-200 dark:bg-slate-900 dark:ring-slate-800"
            >
              <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-slate-900 text-xs font-black text-white dark:bg-white dark:text-slate-900">
                {i + 1}
              </span>
              {rule}
            </li>
          ))}
        </ol>
      </section>
    </PartyHome>
  )
}
